module.exports = function(ngModule) {
  ngModule.config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('contact', {
      url: '/contact',
      template: require('./contact.html'),
      controller: require('./controller.js'),
      controllerAs: 'vm'
    });
  }]);
};
